import { axiosClient } from "./axiosClient"

export const CUT_PATH = '/api/v1/cut'

export const addCut = (body) => {
    return axiosClient.post(CUT_PATH, body)
}

export const getAllCuts = ({ productionPlanId = "", orderId = "" }) => {
    return axiosClient.get(`${CUT_PATH}/all?productionPlanId=${productionPlanId}&orderId=${orderId}`)
}

export const updateCut = (id, body) => {
    return axiosClient.put(`${CUT_PATH}/${id}`, body)
}

export const deleteCut = (id) => {
    return axiosClient.delete(`${CUT_PATH}/${id}`)
}

// export const getCustomerById = (id) => {
//     return axiosClient.get(`${CUSTOMER_PATH}/${id}`)
// }

// export const getPageCustomers = ({ lastId = '', id = "", code = '', name = '' }) => {
//     return axiosClient.get(`${CUSTOMER_PATH}/page?lastId=${lastId}&id=${id}&code=${code}&name=${name}`)
// }